var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100vw","height":"100vh","background-color":"rgb(1, 1, 1, 0.5)","position":"absolute"}},[_vm._v(" egeg ")])
}
var staticRenderFns = []

export { render, staticRenderFns }